import { render, staticRenderFns } from "./LevelsStep.vue?vue&type=template&id=275c99f9&scoped=true&"
import script from "./LevelsStep.vue?vue&type=script&lang=js&"
export * from "./LevelsStep.vue?vue&type=script&lang=js&"
import style0 from "./LevelsStep.vue?vue&type=style&index=0&id=275c99f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c99f9",
  null
  
)

export default component.exports